<template>
  <div class="product product-content-component" v-bind:style="product.boxStyles">

    <div class="product-content">

      <div class="product-content-detail-left product-content-detail" v-bind:class="[product.orientation == 'right' ? 'hidden-element' : '']">
        <ProductDetails :product="product"></ProductDetails>
      </div>

      <div v-if="product.device" class="product-content-device" v-bind:style="{ transform: 'rotate(' + product.device.rotation + ')' }" v-bind:class="[product.device.color == 'white-device' ? 'white-device' : '', product.device.color == 'gray-device' ? 'gray-device' : '', product.device.color == 'black-device' ? 'black-device' : '']">
        <img :src="product.device.image" alt="">
      </div>

      <div v-if="product.name == 'Measure'" class="product-content-measure">
        <img src="../../assets/measure-screenshot.png" alt="">
      </div>

      <div class="product-content-detail-right product-content-detail" v-bind:class="[product.orientation == 'left' ? 'hidden-element' : '']">
        <ProductDetails :product="product"></ProductDetails>
      </div>

    </div>

  </div>
</template>

<script>

import ProductDetails from './ProductDetails'

export default {
  props: ['product'],
  components: {
    ProductDetails
  },
  mounted() {
    if (!window.sr) window.sr = ScrollReveal()
    window.sr.reveal('.product-content-component', { delay: 250, duration: 500 })
  },
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style scoped>

  .hidden-element {
    display: none;
    opacity: 0;
    visibility: hidden;
    width: 0 !important;
    height: 0 !important;
  }

  @media only screen and (max-width: 800px) {
    .hidden-element {
      display: block !important;
      width: auto !important;
      height: auto !important;
      visibility: visible;
      opacity: 1;
    }
  }

  .product-content {
    display: block;
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding-top: 72px;
    padding-bottom: 48px;
  }

  .product {
    overflow: hidden;
  }

  @media only screen and (max-width: 800px) {
    .product-content {
      width: 100%;
      padding: 0;
      padding-top: 48px;
    }
  }

  .product-content-device,
  .product-content-detail {
    display: inline-block;
    width: 40%;
    vertical-align: top;
  }

  @media only screen and (max-width: 800px) {
    .product-content-device,
    .product-content-detail {
      display: inline-block;
      width: 85% !important;
      margin: 0 auto;
    }
  }

  @media only screen and (max-width: 800px) {
    .product-content-device,
    .product-content-detail {
      display: block;
      width: 85% !important;
      margin: 0 auto;
    }
  }

  @media only screen and (max-width: 800px) {
    .product-content-detail-right  {
      display: none !important;
    }
  }

  .product-content-detail-left .product-content-desc {
    text-align: left;
  }

  .product-content-detail-right .product-content-desc {
    text-align: right;
  }

  @media only screen and (max-width: 800px) {
    .product-content-desc {
      width: 400px;
      padding: 12px;
    }
  }

  @media only screen and (max-width: 550px) {
    .product-content-desc {
      width: 90%;
      padding: 6px;
    }
  }

  .white-device {
    background: url('../../assets/white-device.png');
  }

  .gray-device {
    background: url('../../assets/gray-device.png');
  }

  .black-device {
    background: url('../../assets/black-device.png');
  }

  .product-content-device {
    background-size: 300px;
    background-repeat: no-repeat;
    background-position: center 0px;
    margin-top: -24px;
    margin-bottom: -12px;
    padding-bottom: 90px;
  }

  @media only screen and (max-width: 800px) {
    .product-content-device {
      background-size: 390px;
      background-position: center 0px;
      margin-top: 48px;
      transform: rotate(0deg) !important;
    }
  }

  @media only screen and (max-width: 550px) {
    .product-content-device {
      background-size: 95%;
      background-position: center 0px;
      margin-top: 24px;
      transform: rotate(0deg) !important;
    }
  }

  .product-content-device img {
    width: 250px;
    margin-top: 80px;
  }

  @media only screen and (max-width: 800px) {
    .product-content-device img {
      width: 400px;
    }
    .product-content-device {
      padding-bottom: 170px;
    }
  }

  @media only screen and (max-width: 550px) {
    .product-content-device img {
      width: 80%;
    }
    .product-content-device {
      padding-bottom: 120px;
    }
  }

  .product-content-measure {
    display: inline-block;
    width: 400px;
    overflow: hidden;
  }

  .product-content-measure img {
    display: inline-block;
    width: 90%;
    float: right;
    padding: 13% 0;
  }

  @media only screen and (max-width: 800px) {
    .product-content-measure {
      width: 100%;
    }
    .product-content-measure img {
      width: 90%;
      padding: 0;
      padding-bottom: 24px;
      float: none;
    }
  }

</style>



// WEBPACK FOOTER //
// ProductComponent.vue?240cc130